var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jobelement" }, [
    _c(
      "div",
      {
        class: "jobelement__body jobelement__body--" + this.job.frontendstatus
      },
      [
        _c(
          "dl",
          {
            class:
              "jobelement__header jobelement__header--mailbox jobelement__header--" +
              this.job.frontendstatus
          },
          [
            _c("dt", { staticClass: "jobelement__name" }, [
              _c("div", [_vm._v(_vm._s(_vm.job.name))]),
              _vm._v(" "),
              _c("i", { staticClass: "icofont-tick-mark" }),
              _vm._v(" "),
              _c("i", { staticClass: "icofont-ui-laoding icofont-spin" }),
              _vm._v(" "),
              _c("i", { staticClass: "icofont-exclamation-tringle" }),
              _vm._v(" "),
              _c("i", { staticClass: "icofont-question-circle" })
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "jobelement__namesubline" }, [
              _c("ul", { staticClass: "jobelement__namesubline-list" }, [
                _c(
                  "li",
                  {
                    staticClass:
                      "jobelement__namesubline-listitem jobelement__namesubline-info"
                  },
                  [
                    _vm.job.frontendstatus === "success"
                      ? _c("span", {
                          staticClass: "job-success-text",
                          domProps: { innerHTML: _vm._s(_vm.job.jobInfo) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job.frontendstatus === "success"
                      ? _c("span", { staticClass: "price-net-text" }, [
                          _vm._v("  (netto)")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job.frontendstatus === "error"
                      ? _c("span", {
                          staticClass: "job-info-text",
                          domProps: { innerHTML: _vm._s(_vm.job.jobError) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.job.frontendstatus !== "success" &&
                    _vm.job.frontendstatus !== "error"
                      ? _c("span", {
                          staticClass: "job-info-text",
                          domProps: { innerHTML: _vm._s(_vm.job.jobInfo) }
                        })
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass:
                      "jobelement__namesubline-listitem jobelement__namesubline-listitem--mobileactions"
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "jobelement__mobileaction-list" },
                      [
                        _c(
                          "li",
                          {
                            staticClass:
                              "jobelement__mobileaction-listitem jobelement__mobileaction-listitem--inspect",
                            on: {
                              click: function($event) {
                                return _vm.previewJob(_vm.job)
                              }
                            }
                          },
                          [_c("i", { staticClass: "icofont-ui-search" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass:
                              "jobelement__mobileaction-listitem jobelement__mobileaction-listitem--inspect-success",
                            on: {
                              click: function($event) {
                                return _vm.previewJob(_vm.job)
                              }
                            }
                          },
                          [_c("i", { staticClass: "icofont-ui-search" })]
                        ),
                        _vm._v(" "),
                        _c("li", {
                          staticClass:
                            "jobelement__mobileaction-listitem jobelement__mobileaction-listitem--basket",
                          on: {
                            click: function($event) {
                              return _vm.addToCart(_vm.job)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "refreshfade" } }, [
                          _c("li", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.refreshButtonVisible,
                                expression: "refreshButtonVisible"
                              }
                            ],
                            staticClass:
                              "jobelement__mobileaction-listitem jobelement__mobileaction-listitem--refresh",
                            on: {
                              click: function($event) {
                                return _vm.reloadJob(_vm.job)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass:
                              "jobelement__mobileaction-listitem jobelement__mobileaction-listitem--delete",
                            on: {
                              click: function($event) {
                                return _vm.removeJob(_vm.job)
                              }
                            }
                          },
                          [_c("i", { staticClass: "icofont-trash" })]
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "dl",
          {
            class:
              "jobelement__control jobelement__control--edit-mobile jobelement__control--" +
              this.job.frontendstatus
          },
          [
            _c("dd", { staticClass: "jobelement__namesubline" }, [
              _c("ul", { staticClass: "jobelement__mobileaction-list" }, [
                _c(
                  "li",
                  {
                    staticClass:
                      "jobelement__mobileaction-listitem jobelement__mobileaction-listitem--edit",
                    on: {
                      click: function($event) {
                        return _vm.editJob(_vm.job)
                      }
                    }
                  },
                  [_c("i", { staticClass: "icofont-ui-edit" })]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "dl",
          { staticClass: "jobelement__control jobelement__control--mailbox" },
          [
            _c("dt", { staticClass: "jobelement__control-header" }, [
              _vm._v(
                "\n        " +
                  _vm._s(this.config.lang["job.control.pages"]) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "jobelement__control-value" }, [
              _vm._v("\n        " + _vm._s(_vm.job.logicalPages) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "dl",
          { staticClass: "jobelement__control jobelement__control--mailbox" },
          [
            _c("dt", { staticClass: "jobelement__control-header" }, [
              _vm._v(
                "\n        " +
                  _vm._s(this.config.lang["job.control.recipients"]) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "jobelement__control-value" }, [
              _vm._v("\n        " + _vm._s(_vm.job.recipients) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "dl",
          { staticClass: "jobelement__control jobelement__control--mailbox" },
          [
            _c("dt", { staticClass: "jobelement__control-header" }, [
              _vm._v(
                "\n        " +
                  _vm._s(this.config.lang["job.control.print"]) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "jobelement__control-value" }, [
              _c("span", {
                class:
                  "jobelement__control-value-colortype jobelement__control-value-colortype--" +
                  this.job.colortypemodifier
              }),
              _vm._v(" "),
              _c("span", {
                class:
                  "jobelement__control-value-printtype jobelement__control-value-printtype--" +
                  this.job.printtypemodifier
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "dl",
          { staticClass: "jobelement__control jobelement__control--mailbox" },
          [
            _c("dt", { staticClass: "jobelement__control-header" }, [
              _vm._v(
                "\n        " +
                  _vm._s(this.config.lang["job.control.registered"]) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "jobelement__control-value" }, [
              _c("span", {
                class:
                  "jobelement__control-value-shipmenttype jobelement__control-value-shipmenttype--" +
                  this.job.shipmenttypemodifier
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "jobelement__control-value-registered"
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "dl",
          {
            staticClass:
              "jobelement__control jobelement__control--upload-time jobelement__control--mailbox jobelement__control--mailboxid"
          },
          [
            _c("dt", { staticClass: "jobelement__control-header" }, [
              _vm._v(
                "\n        " +
                  _vm._s(this.config.lang["job.control.upload"]) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "jobelement__control-value" }, [
              _c("span", { staticClass: "text--content-bold" }, [
                _vm._v(_vm._s(_vm.job.uploadDate) + ",")
              ]),
              _vm._v("\n        " + _vm._s(_vm.job.uploadTime) + " Uhr\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass:
              "jobelement__deskaction-list jobelement__deskaction-list--mailbox"
          },
          [
            _c(
              "li",
              {
                staticClass:
                  "jobelement__deskaction-listitem jobelement__deskaction-listitem--edit",
                on: {
                  click: function($event) {
                    return _vm.editJob(_vm.job)
                  }
                }
              },
              [_c("i", { staticClass: "icofont-ui-edit" })]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass:
                  "jobelement__deskaction-listitem jobelement__deskaction-listitem--inspect",
                on: {
                  click: function($event) {
                    return _vm.previewJob(_vm.job)
                  }
                }
              },
              [_c("i", { staticClass: "icofont-ui-search" })]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass:
                  "jobelement__deskaction-listitem jobelement__deskaction-listitem--inspect-success",
                on: {
                  click: function($event) {
                    return _vm.previewJob(_vm.job)
                  }
                }
              },
              [_c("i", { staticClass: "icofont-ui-search" })]
            ),
            _vm._v(" "),
            _c("li", {
              staticClass:
                "jobelement__deskaction-listitem jobelement__deskaction-listitem--basket",
              on: {
                click: function($event) {
                  return _vm.addToCart(_vm.job)
                }
              }
            }),
            _vm._v(" "),
            _c("transition", { attrs: { name: "refreshfade" } }, [
              _c("li", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.refreshButtonVisible,
                    expression: "refreshButtonVisible"
                  }
                ],
                staticClass:
                  "jobelement__deskaction-listitem jobelement__deskaction-listitem--refresh",
                on: {
                  click: function($event) {
                    return _vm.reloadJob(_vm.job)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass:
                  "jobelement__deskaction-listitem jobelement__deskaction-listitem--delete",
                on: {
                  click: function($event) {
                    return _vm.removeJob(_vm.job)
                  }
                }
              },
              [_c("i", { staticClass: "icofont-trash" })]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }